import React, { useState } from 'react';
import { Switch } from '../paper';

import * as Colors from '../../helpers/Colors';

interface ToggleProps {
  name?: string;
  value: boolean;
  disabled: boolean;
  onValueChange?: ((...args: any[]) => any) | undefined;
}
export const Toggle: React.FC<ToggleProps> = ({ name, value, disabled, onValueChange }) => {
  const [toggled, setToggled] = useState(value);

  const transformBoolean = (bool: boolean) => {
    return bool ? 'True' : 'False';
  };

  return (
    <>
      <Switch
        disabled={disabled}
        value={toggled}
        color={Colors.secondary}
        onValueChange={(result) => {
          setToggled(result);
          if (name) onValueChange?.(name, transformBoolean(result));
        }}
      />
    </>
  );
};
